import { 
    Fragment, 
    useState, 
    useEffect 
} from 'react'
import { useNavigate, NavLink } from 'react-router-dom';
import { API } from '../helpers/API'
import LoaderMask from '../helpers/LoaderMask';
import imageHeader from '../../assets/images/seguranca-01.png';
import cadeadoSeguranca from '../../assets/images/cadeado-seguranca.png';
import dispositivosSeguranca from '../../assets/images/dispositivos.png';
import mensagensSeguranca from '../../assets/images/mensagens-falsas.png';
import cardModel from '../../assets/images/card-lorem.png';

const MarchaDosPrefeitos = ( props ) => {

    const navigate = useNavigate();

    const foto = require('../../assets/images/seguranca-01.png');

    const mask = new LoaderMask();
    
    const [data, setData] = useState(false);
    const [error, setError] = useState( false );
    const [success, setSuccess] = useState( false );

    const getContent = async () => {

        mask.open();
        try {

            const data = await API.Common.getPageData( 'ciberseguranca' );
            setData( data.meta );

        }
        catch( error ){
            
            console.info('error');
            console.log(error);
            
            setError( 'Erro ao recuperar página' );
        }
        finally {
            mask.close();
        }
            
    };

    const showMessage = () => {
        const message = document.querySelector( '#form-report' );
        message.scrollIntoView({ behavior: 'smooth' });
    }

    useEffect(() => {

        if( !data ){
            getContent();
        }

        const sections = document.querySelectorAll( '#page-seguranca > section' );
        if( sections.length ){

            const onIntersect = ( entries ) => {
                entries.forEach( ( entry ) => {
                    if( entry.isIntersecting ){
                        entry.target.classList.add( 'visualizado' );
                    }
                });
            };

            const observer = new IntersectionObserver( onIntersect, { rootMargin: '0px 0px -35% 0px' } );
            const earlyObserver = new IntersectionObserver( onIntersect, { threshold: 0.3 } );

            sections.forEach( ( section ) => {
                if( section.classList.contains( 'dicas-seguranca' ) ){
                    earlyObserver.observe( section );
                }
                else {
                    observer.observe( section );
                }
            });

            return () => {
                observer.disconnect();
                earlyObserver.disconnect();
            };

        }

    }, [ data ]);

    if( !data ){ 
        return null;
    }

    return (
    <main id="page-seguranca" className="page-seguranca">

        <section className="introduction wcf">
            <header>
                <h1 dangerouslySetInnerHTML={{ __html: data.hero.hero_title }}></h1>
                {data.hero.hero_desc &&
                <em dangerouslySetInnerHTML={{ __html: data.hero.hero_desc }}></em>}
                {data.hero.hero_button_label &&
                <NavLink to="/ciberseguranca/teste" className="button-security" title="BB Previdência">
                    <strong dangerouslySetInnerHTML={{ __html: data.hero.hero_button_label }}></strong>
                </NavLink>}
            </header>
            {data.hero.cover &&
            <div className='image'>
                <picture>
                    <img src={data.hero.cover} alt="Homem sentado digitando em um notebook" />
                </picture>
            </div>}
        </section>

        <section className='dicas-seguranca'>

            <div className='wcf'>

                { data.sticky.map( (item, index) => (
                    <div key={index} className='card'>
                        <div>
                            {item.dest_icon &&
                            <div className='icons'>
                                <picture>
                                    <img src={item.dest_icon} alt="Cadeado" />
                                </picture>
                            </div>
                            }
                            <h2>{item.dest_title}</h2>
                            {item.dest_desc &&
                            <em>{item.dest_desc}.</em>}
                        </div>
                        {item.dest_button_url &&
                        <a className='button-security' href={item.dest_button_url}>
                            <strong>Saiba mais</strong>
                        </a>}
                    </div>
                ))}

            </div>

        </section>

        <section className='card-assistir'>

            <div className='wcf'>
                
                <header>
                    <h2 dangerouslySetInnerHTML={{ __html: data.video_title }}></h2>
                    {data.video_desc &&
                    <em>{data.video_desc}</em>}
                </header>
                <ul className='cards'>

                    {data.video_section.map( (item, index) => (
                    <li key={index} className='card'>
                        {item.video_image ? (
                            <div className='image'>
                                <picture>
                                    <img src={item.video_image} alt="" />
                                </picture>
                            </div>) : (
                            <div className='image'>
                                <picture>
                                    <img src="" alt="" />
                                </picture>
                            </div>)
                        }
                        <div className='texts'>
                            {item.video_url &&
                            <a href={item.video_url}>
                                <strong>Assista agora</strong>
                            </a>}
                            <h3>{item.video_section_title}</h3>
                            {item.video_section_desc &&
                            <p>{item.video_section_desc}</p>}
                        </div>
                    </li>
                    ))}

                </ul>

            </div>

        </section>

        <section className='pilares wcf'>

            <div className='header'>
                <h2 dangerouslySetInnerHTML={{ __html: data.pillars_header_title }}></h2>
                {data.pillars_header_desc &&
                <em dangerouslySetInnerHTML={{ __html: data.pillars_header_desc }}></em>}
                <ul>
                    {data.pillars_section.map( (item, index) => (
                    <li key={index}>
                        {item.pillars_image &&
                        <i>
                            <img src={item.pillars_image} alt=""/>
                        </i>}
                        <h3>{item.pillars_title}</h3>
                        {item.pillars_desc &&
                        <em dangerouslySetInnerHTML={{ __html: item.pillars_desc }}></em>}
                    </li>
                    ))}
                </ul>
            </div>

        </section>

        <section className='bottom-cards wcf'>
            <div className='card-guides'>
                {data.card_normativos.normativos_image &&
                <img src={data.card_normativos.normativos_image} alt="" />}
                <div>
                    <h2>{data.card_normativos.normativos_title}</h2>
                    {data.card_normativos.normativos_label_button &&
                    <a href="#">
                        <strong>{data.card_normativos.normativos_label_button}</strong>
                    </a>}
                </div>
            </div>
            <div className='card-guides'>
                {data.card_guia.guia_image &&
                <img src={data.card_guia.guia_image} alt="" />}
                <div>
                    <h2>{data.card_guia.guia_title}</h2>
                    {data.card_normativos.normativos_label_button &&
                    <a href="#">
                        <strong>{data.card_guia.guia_label_button}</strong>
                    </a>}
                </div>
            </div>
            <div className="footer">
                <a href="#" className='button-security'>
                    <strong>
                        Saiba Mais
                    </strong>
                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.92 5.62409C11.8724 5.50134 11.801 5.3892 11.71 5.29409L6.71 0.294092C6.61676 0.200853 6.50607 0.126893 6.38425 0.0764322C6.26243 0.0259719 6.13186 0 6 0C5.7337 0 5.4783 0.105788 5.29 0.294092C5.19676 0.38733 5.1228 0.498021 5.07234 0.619843C5.02188 0.741665 4.99591 0.872233 4.99591 1.00409C4.99591 1.27039 5.1017 1.52579 5.29 1.71409L8.59 5.00409H1C0.734784 5.00409 0.48043 5.10945 0.292893 5.29699C0.105357 5.48452 0 5.73888 0 6.00409C0 6.26931 0.105357 6.52366 0.292893 6.7112C0.48043 6.89873 0.734784 7.00409 1 7.00409H8.59L5.29 10.2941C5.19627 10.3871 5.12188 10.4977 5.07111 10.6195C5.02034 10.7414 4.9942 10.8721 4.9942 11.0041C4.9942 11.1361 5.02034 11.2668 5.07111 11.3887C5.12188 11.5105 5.19627 11.6211 5.29 11.7141C5.38296 11.8078 5.49356 11.8822 5.61542 11.933C5.73728 11.9838 5.86799 12.0099 6 12.0099C6.13201 12.0099 6.26272 11.9838 6.38458 11.933C6.50644 11.8822 6.61704 11.8078 6.71 11.7141L11.71 6.71409C11.801 6.61899 11.8724 6.50684 11.92 6.38409C12.02 6.14063 12.02 5.86755 11.92 5.62409Z" fill="#0060A9"/>
                    </svg>
                </a>
            </div>
        </section>

    </main>)

}
export default MarchaDosPrefeitos